import { render, staticRenderFns } from "./ComissionDetails.vue?vue&type=template&id=b4ac741c&scoped=true"
import script from "./ComissionDetails.vue?vue&type=script&lang=js"
export * from "./ComissionDetails.vue?vue&type=script&lang=js"
import style0 from "./ComissionDetails.vue?vue&type=style&index=0&id=b4ac741c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ac741c",
  null
  
)

export default component.exports